
import { TimezoneDto } from "@aoe/client";
import { createReducer, on } from "@ngrx/store";
import { timezoneActions } from "./timezone.actions";

export interface TimezoneState {
    timezones: TimezoneDto[] | null;
    nb: number;
    loading: boolean;
    error?: any,
    warning?: any;
    info?: any;
}

export const initialeState: TimezoneState = {
    timezones: [],
    nb: 0,
    loading: true,
}

export const timezoneReducer = createReducer(
    initialeState,
    on(
        timezoneActions["[Timezone-API]LoadTimezone"], state => ({
            ...state,
            loading: true
        })
    ),
    on(
        timezoneActions["[Timezone-API]LoadSuccess"], (state, res) => ({
            ...state,
            loading: false,
            timezones: res.data?.timezones ?? [],
            nb: res.data?.nb ?? 0,
            info: res.info,
            warning: res.warning,
        })
    ),
    on(
        timezoneActions["[Timezone-API]LoadFailed"], (state, res) => ({
            ...state,
            loading: false,
            error: res.error
        })
    ),
    on(
        timezoneActions["[Timezone-API]ResetTimezone"], state => ({
            ...state,
            loading: false,
            error: null,
            info: null,
            timezones: null,
            warning: null
        })
    ),
)